<template>
  <div>
    <div class="link-wrapper">
      <ul>
        <h5>{{ $t('evaluation.shortLinks') }}</h5>
        <li>
          <a :href="permaLink ? `https://www.venturelab.ch/${permaLink}` : `https://www.venturelab.ch/index.cfm?page=137304&profil_id=${profileId}`" target="_blank">
            <b-button pill variant="primary" size="sm">
              {{ $t('evaluation.showProfileVentureLab') }}
            </b-button>
          </a>
        </li>
        <li>
          <a :href="permaLink ? `https://www.startup.ch/${permaLink}` : `https://www.startup.ch/index.cfm?page=137888&profil_id=${profileId}`" target="_blank">
            <b-button pill variant="primary" size="sm">
              {{ $t('evaluation.showProfileStartup') }}
            </b-button>
          </a>
        </li>
        <li>
          <a :href="`https://crm.ifj.ch/index.cfm?page=133821&PDF_bestellung_id=${addressId}`" target="_blank">
            <b-button pill variant="primary" size="sm">
              {{ $t('evaluation.pdf') }}
            </b-button>
          </a>
        </li>
        <li>
          <a :href="`https://crm.ifj.ch/index.cfm?&page=137659&crm_adresse_id=${crmAdressId}`" target="_blank">
            <b-button pill variant="primary" size="sm">
              {{ $t('evaluation.crmProfile') }}
            </b-button>
          </a>
        </li>
      </ul>
    </div>
    <dx-data-grid
      id="gridContainerEvaluations"
      :data-source="evaluations"
      :show-borders="true"
      :column-auto-width="true"
      @row-updated="onUpdateRow"
      @init-new-row="onInitNewRow"
      @row-inserted="onInsertRow"
    >
      <dx-paging :page-size="5"/>

      <dx-editing
        :allow-updating="true"
        :allow-adding="addStatus"
        mode="row"
      />

      <dx-column
        data-field="field_001"
        :caption="$t('evaluation.list.id')"
        :allow-editing="false"
      />
      <dx-column
        data-field="datum"
        :caption="$t('evaluation.list.date')"
        data-type="date"
        alignment="right"
        :allow-editing="false"
      />
      <dx-column
        data-field="cRMMitarbeiter.vorname"
        :caption="$t('evaluation.list.firstname')"
        :allow-editing="false"
      />
      <dx-column
        data-field="cRMMitarbeiter.nachname"
        :caption="$t('evaluation.list.lastname')"
        :allow-editing="false"
      />
      <dx-column
        :caption="$t('evaluation.list.comment')"
        data-field="comment"
      >
        <dx-string-length-rule
          :max="60"
          message="maximum length (60) achieved"
        />
      </dx-column>
      <dx-column
        data-field="sEMINARCasequality.field_001"
        :caption="$t('evaluation.list.evaluation')"
      >
        <dx-lookup
          :data-source="casequalityTypes"
          display-expr="casequality"
          value-expr="field_001"
        />
        <dx-required-rule/>
      </dx-column>
    </dx-data-grid>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  import {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxLookup,
    DxEditing,
    DxRequiredRule,
    DxStringLengthRule
  } from 'devextreme-vue/data-grid'

  export default {
    data: () => ({
      evaluations: [],
      evaluationTypes: [],
      addStatus: true
    }),
    created () {
      this.getEvaluations()
    },
    methods: {
      checkAlreadySignedUp () {
        const currentUserId = this.currentUser.mitarbeiterId
        const alreadySignUp = this.evaluations.find(x => x.cRMMitarbeiter.field_001 === currentUserId)
        if (alreadySignUp) {
          this.addStatus = false
        } else {
          this.addStatus = true
        }
      },
      async getEvaluations () {
        try {
          const data = await this.$store.dispatch('recherche/GET_EVALUATIONS', this.addressId)
          this.evaluations = data
          this.checkAlreadySignedUp()
        } catch (err) {
          console.error(err)
        }
      },
      async onUpdateRow (rowData) {
        const { field_001: id, comment, sEMINARCasequality } = rowData.data

        try {
          await this.$store.dispatch('recherche/UPDATE_EVALUATION', {
            formData: {
              id,
              comment,
              evulationId: sEMINARCasequality.field_001,
              mitarbeiterId: this.currentUser.mitarbeiterId,
              addressId: this.addressId
            }
          })
          this.getEvaluations()
        } catch (err) {
          console.error(err)
        }
      },
      async onInsertRow (rowData) {
        const { comment, sEMINARCasequality } = rowData.data

        if (sEMINARCasequality) {
          try {
            await this.$store.dispatch('recherche/CREATE_EVALUATION', {
              formData: {
                comment,
                evulationId: sEMINARCasequality.field_001,
                mitarbeiterId: this.currentUser.mitarbeiterId,
                addressId: this.addressId
              }
            })
            this.getEvaluations()
          } catch (err) {
            console.error(err)
            this.getEvaluations()
          }
        }
      },
      async onInitNewRow (rowData) {
        rowData.data.cRMMitarbeiter = {}
        const { firstName, lastName } = this.currentUser
        rowData.data.cRMMitarbeiter.vorname = firstName
        rowData.data.cRMMitarbeiter.nachname = lastName
      }
    },
    computed: {
      ...mapState({
        currentUser: state => state.user.currentUser
      }),
      ...mapGetters({
        casequalityTypes: 'basicValues/CASEQUALITY_TYPES'
      })
    },
    components: {
      DxDataGrid,
      DxColumn,
      DxPaging,
      DxLookup,
      DxEditing,
      DxRequiredRule,
      DxStringLengthRule
    },
    props: {
      addressId: {
        type: Number,
        required: true
      },
      permaLink: {
        type: String
      },
      profileId: {
        type: Number,
        required: true
      },
      crmAdressId: {
        type: Number,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .link-wrapper{
    padding: 1rem;

    ul{
      padding: 0;
      margin: 0;
      list-style: none;

      li{
        display: inline;
        padding: 0 10px 0 0;
      }

      h5{
        display: inline;
        margin-right: 15px;
      }
    }
  }

  #gridContainerEvaluations{
    padding: 0 15px 15px
  }
</style>
